import type { Capability } from "owa-capabilities";
import type { MailboxInfo } from "owa-client-types";
import { RegisterForAccountStateChange } from "owa-account-source-list";
import { type AccountSource } from "owa-account-source-list-store";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { areAnyAccountsEnterpriseOrPremiumConsumer } from "./utils/areAnyAccountsEnterpriseOrPremiumConsumer";

let checked = false;
let enabled = false;

/**
 * This capability is used to determine if MSG and OFT capabilities should be supported.
 *
 * NOTE: Please see the README for more information on how the
 * capability functions must be implemented and used.
 *
 */
export const msgOftCapability: Capability = {
    isEnabled: (_mailboxInfo?: MailboxInfo) => {
        if (checked) {
            return enabled;
        }
        
        enabled = areAnyAccountsEnterpriseOrPremiumConsumer();
        checked = true;
        
        RegisterForAccountStateChange(onAccountsChanged, onAccountsChanged);
        
        return enabled;
    },
    isSupported: (_mailboxInfo?: MailboxInfo) => {
        return isGlobalFeatureEnabled("mon-file-eml-msg");
    },
};

// Callback for when an account is added or removed
const onAccountsChanged = async (_accountSource: AccountSource) => {
    enabled = areAnyAccountsEnterpriseOrPremiumConsumer();
};
